<template>
  <v-card>
    <runner-data-personal :runner="runnerData" @runner-updated="fetchRunner"></runner-data-personal>
    <v-divider class="mb-2"/>
    <runner-data-gear :runner="runnerData" @runner-updated="fetchRunner"></runner-data-gear>
    <v-divider class="mb-2"/>
    <runner-data-running :runner="runnerData" @runner-updated="fetchRunner"></runner-data-running>
    <v-divider class="mb-2"/>
    <runner-data-other :runner="runnerData" @runner-updated="fetchRunner"></runner-data-other>
    <v-divider class="pb-2"/>
  </v-card>
</template>

<script>
import {getRunner} from './api'
import * as types from '@/store/mutation-types'
import { mapGetters, mapState } from 'vuex'
import RunnerDataPersonal from './RunnerDataPersonal'
import RunnerDataGear from './RunnerDataGear'
import RunnerDataRunning from './RunnerDataRunning'
import RunnerDataOther from './RunnerDataOther'

export default {
  components: {RunnerDataPersonal, RunnerDataGear, RunnerDataRunning, RunnerDataOther},
  data () {
    return {
      updateMode: false,
      formErrors: {},
      runnerData: {},
      runnerApplicationData: {}
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions', 'authUser', 'isAdmin', 'isRunner', 'isActiveRunner']),
    ...mapState(['runnersTrainer', 'runner'])
  },
  created () {
    this.fetchRunner()
    this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
  },
  watch: {
    '$route': 'fetchRunner'
  },
  methods: {
    fetchRunner () {
      getRunner(this.runner.id).then((data) => {
        this.runnerData = data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/RunnerData.vue